import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { WorkflowNote, ApplicationFlowHistory } from '../models/applications.models';

@Injectable({
  providedIn: 'root'
})
export class ApplicationNotesService {

    private _activeNote: WorkflowNote;

    get activeNote(): WorkflowNote {
        return this._activeNote;
    }

    get fieldId(): number {
        if (this._activeNote == null) return null;
        return this._activeNote.fieldId;
    }

    private history: BehaviorSubject<ApplicationFlowHistory[]> = new BehaviorSubject<ApplicationFlowHistory[]>([]);
    private notes: BehaviorSubject<WorkflowNote[]> = new BehaviorSubject<WorkflowNote[]>([]);

    private noteSaved: EventEmitter<WorkflowNote> = new EventEmitter<WorkflowNote>();

    noteSaved$: Observable<WorkflowNote> = this.noteSaved.asObservable();

    get timeline(): Observable<ApplicationFlowHistory[]> {
        return  this.history.asObservable();
    }

    visibleNotes: Observable<WorkflowNote[]> = this.notes.asObservable().pipe(
        map((data: WorkflowNote[]) => {
            if (this._activeNote != null) return this.workflowNotes.filter(n => n.fieldId == this.fieldId && n.id != this._activeNote.id);
            return this.workflowNotes.filter(n => n.fieldId == this.fieldId);
        })
    )

    get workflowNotes(): WorkflowNote[] {
        return this.notes.value;
    }

    constructor() { }


    add(note: WorkflowNote): void {
        this._activeNote = note;
    }

    cancelNote(): void {
        this._activeNote = null;
    }

    saveNote(): void {
        this.noteSaved.emit(this.activeNote);
        this._activeNote = null;
    }

    saveReply(note: WorkflowNote): void {
        this.noteSaved.emit(note);
        this._activeNote = null;

    }

    updateHistory(events: ApplicationFlowHistory[]): void {
        this.history.next(events);
    }

    updateNoteList(selectedNotes: WorkflowNote[]): void {
        this.notes.next(selectedNotes);
    }

}
